module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0f1feb8570cba8353844fc5747783d8f.png";